import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { AppComponent } from '../app.component';
import { BuscarService } from '../_services/buscar.service';
import { DataService } from '../_services/data.service';
import { MatriculacionService } from '../_services/matriculacion.service';
import * as $ from "jquery";
@Component({
  selector: 'app-buscar-tramite',
  templateUrl: './buscar-tramite.component.html',
  styleUrls: ['./buscar-tramite.component.scss']
})
export class BuscarTramiteComponent implements OnInit {

  formBusquedaTramite!: FormGroup;
  anularForm!: FormGroup;
  formEnviado!: Boolean;
  formEnviando!: Boolean;
  sinResultados!: Boolean;
  error!: Boolean;
  validaciones!: Boolean;
  mostrarResultado: Boolean = false;
  resultado: any = null;
  resultadosVacio!:string;
  errorArchivoDes!:string;
  resultadoMatricula: any;
  idProcesoSeleccionado:any;
  showAdmin!:boolean;
  constructor(private formBuilder: FormBuilder,
              private buscarService: BuscarService,
              private matriculacionService:MatriculacionService,
              private dataService: DataService,
              private router: Router,
              private matriculaService:MatriculacionService,
              private appComponent:AppComponent) {
  }

  get formulario(): { [key: string]: AbstractControl } {
    return this.formBusquedaTramite.controls;
  }

  get formularioAnular(): { [key: string]: AbstractControl } {
    return this.anularForm.controls;
  }

  ngOnInit(): void {
    this.showAdmin=this.appComponent.showAdmin;
    this.formBusquedaTramite = this.formBuilder.group(
      {
        nro_doc: [null, Validators.compose(
          [
            Validators.required,
            Validators.pattern('^[0-9]{6,8}$')
          ])],
        tipo_doc: ['DNI', Validators.required],

      }
    );

    this.anularForm = this.formBuilder.group(
      {
        observacion: [null, Validators.required],
      }
    );
  }

  ngOnDestroy() {
    this.dataService.datosMatricula = this.resultadoMatricula;
  }

  onSubmit() {
    this.validaciones = true;
    if (this.formBusquedaTramite.valid) {
        this.buscar();
    }
  }
  onSubmitAnular() {
    this.validaciones = true;
    if (this.anularForm.valid) {
        this.anularCertificado();
    }
  }

  anularCertificado(){
    let form:any={};
    let formObj = this.anularForm.getRawValue();
    form.id_proceso=this.idProcesoSeleccionado;
    form.id_usuario=this.appComponent.usuarioLogueado?.idUsuario;
    form.observaciones=formObj.observacion;
    this.matriculaService.anularCertificado(form).subscribe(result=>{
      debugger
      Swal.fire({
        title: 'Correcto!',
        text: 'El certificado ha sido anulado con exito',
        icon: 'success',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar'
      }).then(respuesta => {
        this.onSubmit();
        $("#closeModal").click();
      });
    },(error)=>{

    });

  }

  buscar() {
    this.error = false;
    this.resultado = null;
    let formObj = this.formBusquedaTramite.getRawValue();
    this.buscarService.buscarTramite(formObj.tipo_doc, formObj.nro_doc).subscribe(result => {
      if (result.length > 0) {
        this.resultado = result;
        this.formEnviado = true;
        this.sinResultados = false;
      } else {
        this.formEnviado = false;
        this.sinResultados = true;
        this.validaciones = false;
      }
    }, (error) => {
      this.resultadosVacio=error;
      this.formEnviado = false;
      this.sinResultados = true;
      this.validaciones = false;
    });

  }

  descargarArchivo(id: number, apellido: string,dni:string) {
    this.buscarService.descargarArchivo(id).subscribe(result => {
      this.downloadPdf(result.pdf, apellido + "_" + dni);
    }, (error) => {
      this.errorArchivoDes=error;
      this.error = true;
    });
  }

  downloadPdf(base64String: any, fileName: any) {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      let byteChar = atob(base64String);
      let byteArray = new Array(byteChar.length);
      for (let i = 0; i < byteChar.length; i++) {
        byteArray[i] = byteChar.charCodeAt(i);
      }
      let uIntArray = new Uint8Array(byteArray);
      let blob = new Blob([uIntArray], { type: 'application/pdf' });
      window.navigator.msSaveOrOpenBlob(blob, `${fileName}.pdf`);
    } else {
      const source = `data:application/pdf;base64,${base64String}`;
      const link = document.createElement("a");
      link.href = source;
      link.download = `${fileName}.pdf`
      link.click();
    }
  }

  continuarTramite(idProceso:any){
    let body:any={};
    body.idProceso=idProceso;
    this.resultadoMatricula=null;
    this.matriculacionService.continuarTramite(body).subscribe(result=>{
      this.resultadoMatricula = result;
      this.router.navigate(["/info-firmas"]);
    },(error)=>{

    });
  }

  reintentarFirma(idProceso:any){
    var firma:any={};
    firma.idProceso=idProceso;
    this.matriculaService.reintentarFirma(firma).subscribe(result => {
      window.location.href = result.url;
    }, (error) => {
      this.errorArchivoDes=error;
      this.error = true;
    });
  }

  anular(idProceso:any){
    this.validaciones=false;
    this.anularForm.reset();
    this.idProcesoSeleccionado=idProceso;
    debugger
  }
}
